import React, { useContext, useState } from 'react';
import { InputField } from '@trp-beacon-ui-kit/react-controls';
import { FlowContext } from '../../core/flow-engine';
import { MFBeaconButton, MFBeaconModal } from '../Beacon/BeaconComponents';
import styles from './RPSPlansBySSNModal.css';
import { SSN_REGEX } from '../../flows/shared/testers';
import { handleInputFormat } from '../../flows/shared/utils';
import { modalCloseNextModalHandler } from '../Modal/utils';

const RPSPlansBySSNModal = () => {
  const { formProps, closeNextModal, next } = useContext(FlowContext);

  const [disableBtn, setDisableBtn] = useState(true);
  const [ssnValue, setSSNValue] = useState('');

  const handleRPSSSN = ({ target: { value } }) => {
    const isValidSSN = SSN_REGEX.test(value);
    if (isValidSSN) {
      setDisableBtn(false);
    }
  };

  const routeToRPSFlow = async () => {
    await next({
      section: 'rpsSSNModal'
    })();
  };

  return (
    <>
      <MFBeaconModal open removeCloseButton>
        <InputField
          type="text"
          title="Please enter the participant's SSN to continue forward in the OCR process"
          placeholder="000-00-0000"
          maxLength="11"
          onChange={evt => {
            handleRPSSSN(evt);
            handleInputFormat(evt, 'SSN', setSSNValue);
          }}
          {...formProps.rpsSSN}
          value={ssnValue}
        />
        <div className="rps-ssn-btn-container" slot="action-zone">
          <MFBeaconButton
            variant="primary"
            disabled={disableBtn}
            noButtonMargin
            onClick={() => {
              modalCloseNextModalHandler(closeNextModal);
              routeToRPSFlow();
            }}
            id="rpsPlansBySSNModalContinue"
            data-name="rpsPlansBySSNModalContinue"
            label="Continue"
          />
        </div>
      </MFBeaconModal>
      <style jsx>{styles}</style>
    </>
  );
};

export default RPSPlansBySSNModal;
